import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=32920e92&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32920e92",
  null
  
)

export default component.exports